import React, { memo } from 'react'
import { Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  .form-label {
    white-space: nowrap;
  }
`
const StyledSwitch = styled.div`
  font-weight: bold;
  display: flex;
  flex-direction: row-reverse;
`
const HeaderData = memo(({
    headerData,
    setHeaderDataByKey,
    formErrors,
    resetErrorByFormKey,
}) => {


  const handleCange = (e) => {
    const { name, checked } = e.target
    setHeaderDataByKey(name, checked)
    resetErrorByFormKey(name)
  }
  const { t } = useTranslation()
  const disabled = headerData.metaProperties && headerData.metaProperties.find(metaProp => (metaProp.pointer === '/refundShipmentCosts' && metaProp.attributes === 'isReadOnly'))
  return (
    <>
      <StyledWrapper className="spacing-down">
      <StyledSwitch>
        <Form.Check
        type="switch"
        id="custom-switch"
        name="refundShipmentCosts"
        label={t('returnsProcessingPage:refundShipmentCosts')}
        onChange={handleCange}
        checked={headerData.refundShipmentCosts}
        disabled={disabled}
        />
        </StyledSwitch>
      </StyledWrapper>
    </>
  )
})

export default HeaderData
